import Vue from 'vue'
import kuangkuang from '@/create-ui/kuangkuang/index'
import loading from '@/create-ui/loading/index'
import page from '@/create-ui/page/index'
import table from '@/create-ui/table/index'
const coms = [kuangkuang, loading, page, table]

//批量注册组件
const install = function () {
    coms.forEach(com => {
        Vue.component(com.name, com)
    })
}
export default install